// extracted by mini-css-extract-plugin
export var actions = "_s6-4";
export var item = "_s6-1";
export var price = "_s6-3";
export var quantity = "_s6-2";
export var table = "_s6-0";